import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const thankUGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  // Check if navigation includes the 'submitted' state
  const navigation = router.getCurrentNavigation();
  const isSubmitted = navigation?.extras.state?.['submitted'] === true;

  if (isSubmitted) {
    return true;
  }

  // Redirect to home or the specific landing if accessed directly
  return router.createUrlTree(['/landing/mad-from-ccs']);
};
